import { useState, useRef } from 'react';
import Modal from '../../Atoms/Modal/Modal';
import ModalChildrenContainer from '../../Atoms/Modal/ModalChildrenContainer';
import Buttons from '../../Atoms/Buttons/Buttons';
import styles from './ReorderModal.module.scss';
import reorderIcon from '../../../assets/Imagess/reorder.svg';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../Constants';
import { useToast } from '../Custom/CustomToaster/Toast';

const ReorderModal = ({ handleOnClose, refetch, items }) => {
  const customizedToast = useToast();

  const [list, setList] = useState(() => {
    if (!Array.isArray(items)) return [];
    const hasSeq = items.every((it) => typeof it?.sequenceId === 'number');
    return hasSeq
      ? [...items].sort((a, b) => (a.sequenceId ?? 0) - (b.sequenceId ?? 0))
      : [...items];
  });

  const dragIndex = useRef(null);

  const updateSequence = useMutation({
    mutationFn: (fields) => {
      return axios.post(
        API_URL + `/api/HomePage/ReorderHomePageSlides`,
        fields,
        {
          headers: securityHeaders,
        }
      );
    },
    onSuccess: () => {
      customizedToast.open('تم تحديث الترتيب');
      refetch();
      handleOnClose();
    },
  });

  const onDragStart = (idx) => (e) => {
    dragIndex.current = idx;
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', String(idx));
  };

  const onDragOver = (idx) => (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const onDrop = (idx) => (e) => {
    e.preventDefault();
    const from = dragIndex.current;
    const to = idx;
    if (from === null || to === null || from === to) return;

    setList((prev) => {
      const next = [...prev];
      const [moved] = next.splice(from, 1);
      next.splice(to, 0, moved);
      return next;
    });

    dragIndex.current = null;
  };

  const onDragEnd = () => {
    dragIndex.current = null;
  };

  const handleSave = () => {
    const payload = list.map((it, idx) => ({
      id: it?.id,
      sequenceId: idx + 1,
    }));
    console.log(payload);
    updateSequence.mutate(payload);
  };

  return (
    <Modal
      onClose={handleOnClose}
      title='إعادة ترتيب شريط التمرير'
      width='35rem'
      closeWhite={false}
    >
      <ModalChildrenContainer>
        <div className={styles['order-container']}>
          {list?.map((item, idx) => (
            <div
              className={styles['item']}
              key={item?.id}
              draggable
              onDragStart={onDragStart(idx)}
              onDragOver={onDragOver(idx)}
              onDrop={onDrop(idx)}
              onDragEnd={onDragEnd}
            >
              <div className={styles['title-container']}>
                <p className={styles['order-number']}>{idx + 1}</p>
                <p className={styles['order-title']}>{item?.title}</p>
              </div>
              <img src={reorderIcon} alt='' />
            </div>
          ))}
        </div>

        <Buttons
          text={'حفظ'}
          handleOnClick={handleSave}
          rounded={true}
          style={{
            marginTop: '14px',
            padding: '16px 19px',
            borderRadius: '50px',
            fontFamily: 'BukraBold',
            fontSize: '20px',
          }}
        />
      </ModalChildrenContainer>
    </Modal>
  );
};

export default ReorderModal;
